import type { ContactsTranslations } from "../../types/contacts";

export const contacts: ContactsTranslations = {
  sidebar: "Contacts",
  title: "Contacts",
  subtitleProject: "Phone numbers, emails and notes for everyone on this project",
  subtitleBuilding: "Contacts for every project in this building",
  search: "Search contacts…",
  add: "Add contact",
  count: "Contacts: {count}",
  allProjects: "All projects",
  filter: {
    label: "Responsibilities",
    empty: "No disciplines found.",
  },
  empty: "No contacts yet.",
  emptySearch: "No contacts match your search.",
  loadFailed: "Contacts could not be loaded. Please try again.",
  unavailable: "Contacts aren't available yet. Please try again later.",
  columns: {
    name: "Name",
    company: "Position and company",
    responsibilities: "Responsibilities",
    phones: "Phone",
    emails: "Email",
    notes: "Notes",
  },
  badges: {
    external: "External",
    noAccess: "No longer has access",
    you: "You",
  },
  actions: {
    menu: "Contact actions",
    edit: "Edit",
    delete: "Delete",
    addDetails: "Add details",
    copy: "Copy",
    copied: "Copied",
    copyFailed: "Could not copy. Please try again.",
  },
  enteredBy: "Added by {name}",
  form: {
    createTitle: "Add contact",
    editTitle: "Edit contact",
    memberTitle: "Contact details for {name}",
    project: "Project",
    projectPlaceholder: "Choose a project",
    name: "Name",
    memberNameHint: "The name comes from their Franklin profile.",
    accountEmail: "Account email",
    company: "Company",
    jobTitle: "Position",
    jobTitlePlaceholder: "e.g. Site manager",
    responsibilities: "Responsibilities",
    responsibilitiesPlaceholder: "Add disciplines",
    phones: "Phone numbers",
    emails: "Email addresses",
    notes: "Notes",
    notesPlaceholder: "Availability and anything else worth knowing",
    addPhone: "Add phone number",
    addEmail: "Add email address",
    labelPlaceholder: "Label, e.g. Mobile",
    phonePlaceholder: "+372 5555 1234",
    emailPlaceholder: "name@example.com",
    remove: "Remove",
    save: "Save",
    cancel: "Cancel",
  },
  errors: {
    projectRequired: "Choose a project.",
    required: "Enter a name.",
    tooLong: "This is too long.",
    phoneFormat: "A phone number needs at least one digit.",
    emailFormat: "Enter a valid email address.",
    labelTooLong: "The label can be at most 50 characters.",
    tooManyPhones: "Add at most 10 phone numbers.",
    tooManyEmails: "Add at most 10 email addresses.",
    notEditable: "You can't change this contact.",
    createDenied: "You can't add a contact to this project.",
    editConflict:
      "This edit could not be saved. The contact may have changed or become inaccessible. Refresh the list and try again.",
    confirmationUnknown:
      "Could not confirm whether the contact changed. Refresh the list before trying again.",
    alreadyExists: "Someone has already added details for this person. Refreshing the list.",
    saveFailed: "The contact could not be saved. Please try again.",
    deleteFailed: "The contact could not be deleted. Please try again.",
  },
  deleteDialog: {
    title: "Delete contact?",
    description: "{name} will be removed from this project's contacts.",
    memberDescription:
      "The phone numbers, emails and notes entered for {name} on this project will be removed. Their access is not affected.",
    buildingDescription:
      "The phone numbers, emails and notes entered for {name} in this building will be removed. Their access is not affected.",
    confirm: "Delete",
  },
  toast: {
    saved: "Contact saved",
    deleted: "Contact deleted",
  },
};
